import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Phone, MapPin, Instagram, Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#050d0a] text-amber-100/70 overflow-hidden border-t border-amber-600/20">
      {/* Decorative top vine border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500 to-transparent" />

      <div className="absolute inset-0 opacity-30">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="firefly"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-700 to-amber-600 rounded-lg flex items-center justify-center mystical-glow-gold border border-amber-500/40">
                <Sparkles className="w-7 h-7 text-amber-100" />
              </div>
              <span className="text-xl font-bold text-amber-100" style={{ fontFamily: 'Cinzel, serif' }}>
                The Divine7777
              </span>
            </div>
            <p className="text-sm text-amber-100/60 leading-relaxed">
              Step into the mystical garden of wisdom. Professional Tarot, Angel & Oracle Card guidance from Meeta Jain.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-amber-400 font-semibold mb-4 uppercase tracking-widest text-sm" style={{ fontFamily: 'Cinzel, serif' }}>
              Quick Links
            </h3>
            <ul className="space-y-2">
              {['Home', 'Services', 'Crystals', 'Blog', 'Videos', 'Testimonials', 'About'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="text-sm hover:text-amber-300 transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-amber-400 font-semibold mb-4 uppercase tracking-widest text-sm" style={{ fontFamily: 'Cinzel, serif' }}>
              Sacred Offerings
            </h3>
            <ul className="space-y-2 text-sm text-amber-100/70">
              <li>30 Minute Reading Session</li>
              <li>7 Day WhatsApp Guidance</li>
              <li>21 Days Guidance Program</li>
              <li>Healing Sessions</li>
              <li>Event Bookings</li>
              <li>Crystal Products</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-amber-400 font-semibold mb-4 uppercase tracking-widest text-sm" style={{ fontFamily: 'Cinzel, serif' }}>
              Connect
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center text-sm">
                <Phone className="w-4 h-4 mr-2 text-amber-500" />
                <a href="https://wa.me/919681424041" className="hover:text-amber-300 transition-colors">
                  +91 9681424041
                </a>
              </li>
              <li className="flex items-start text-sm">
                <MapPin className="w-4 h-4 mr-2 text-amber-500 mt-0.5" />
                <span>Kolkata, West Bengal, India</span>
              </li>
            </ul>

            <div className="mt-5">
              <h4 className="text-amber-400/80 font-semibold mb-3 text-xs uppercase tracking-widest">Follow</h4>
              <div className="flex space-x-3">
                <a
                  href="https://www.youtube.com/@thedivine7777"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-emerald-900/60 border border-amber-600/30 rounded-full flex items-center justify-center hover:bg-emerald-800 hover:border-amber-500 transition-all"
                  aria-label="YouTube"
                >
                  <Youtube className="w-4 h-4 text-amber-400" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-emerald-900/60 border border-amber-600/30 rounded-full flex items-center justify-center hover:bg-emerald-800 hover:border-amber-500 transition-all"
                  aria-label="Instagram"
                >
                  <Instagram className="w-4 h-4 text-amber-400" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-emerald-900/60 border border-amber-600/30 rounded-full flex items-center justify-center hover:bg-emerald-800 hover:border-amber-500 transition-all"
                  aria-label="Facebook"
                >
                  <Facebook className="w-4 h-4 text-amber-400" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-amber-600/20 text-center text-sm text-amber-100/50">
          <p>&copy; {currentYear} The Divine7777 · Meeta Jain · All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
